export const ProductStatus: any = {
  NOT_SELECTED: {
    name: "NOT_SELECTED",
    bgColor: "#F8F8F8",
    color: "#4A4A4A",
    borderColor: "#F8F8F8",
  },
  UNTRUSTED: {
    name: "UNTRUSTED",
    bgColor: "#CA310B",
    color: "#fff",
    borderColor: "#CA310B",
  },
  INPROGRESS: {
    name: "INPROGRESS",
    bgColor: "#FFC107",
    color: "#fff",
    borderColor: "#FFC107",
  },
  APPROVED: {
    name: "APPROVED",
    bgColor: "#AACD34",
    color: "#fff",
    borderColor: "#AACD34",
  },
};
